import { Epic, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Action } from '../../../actions';
import {
    SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES,
    SaveInternalBannerNameEditorChanges
} from '../../../actions/bannersEdit/internal/saveInternalBannerNameEditorChanges';
import {
    UpdateInternalBannerDescription,
    updateInternalBannerDescriptionAction
} from '../../../actions/bannersEdit/internal/updateInternalBannerDescription';
import {
    closeEditPageItemNameEditor,
    CloseEditPageItemNameEditorAction,
    showEditPageItemNameEditorErrors,
    ShowEditPageItemNameEditorErrorsAction
} from '../../../actions/editPageItemNameEditor';
import { selectEditPageItemNameEditorValue } from '../../../selectors/editPageItemNameEditor/editPageItemNameEditor';
import { getBannerEditPageItemEditorId } from '../../../service/BannerHelpers/BannerHelpers';
import { getInternalBannerDescriptionEditorValidationResult } from '../../../service/InternalBannerHelpers/InternalBannerHelpers';
import { EpicDeps } from '../../../service/StoreFactory';
import { State } from '../../../typings/state';

type EpicActions =
    | UpdateInternalBannerDescription
    | CloseEditPageItemNameEditorAction
    | ShowEditPageItemNameEditorErrorsAction;

export const saveInternalBannerNameEditorChangesEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(SAVE_INTERNAL_BANNER_NAME_EDITOR_CHANGES),
        switchMap(
            (action: SaveInternalBannerNameEditorChanges): Observable<EpicActions> => {
                const state = store$.value;
                const { bannerId } = action;
                const { editPageItemNameEditor: editors } = state;
                const editorId = getBannerEditPageItemEditorId(bannerId);
                const editorData = selectEditPageItemNameEditorValue(editors, editorId);

                const validationErrors = getInternalBannerDescriptionEditorValidationResult(state, bannerId);

                if (validationErrors.length === 0) {
                    return of(
                        updateInternalBannerDescriptionAction(bannerId, editorData.value),
                        closeEditPageItemNameEditor(editorId)
                    );
                }

                return of(showEditPageItemNameEditorErrors(editorId, validationErrors));
            }
        )
    );
};
